'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOGOUTDERECTLY = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.isLoaded = isLoaded;
exports.infoChangeSubmit = infoChangeSubmit;
exports.isPersonalUserLoaded = isPersonalUserLoaded;
exports.showUserLoginModel = showUserLoginModel;
exports.pwdChange = pwdChange;
exports.pwdChangeSubmit = pwdChangeSubmit;
exports.load = load;
exports.getPersonalCenterCarouselImgs = getPersonalCenterCarouselImgs;
exports.loadPublicUser = loadPublicUser;
exports.login = login;
exports.logout = logout;
exports.forgetPasswordSubmit = forgetPasswordSubmit;
exports.getCode = getCode;
exports.getUserInfo = getUserInfo;
exports.clearInfoChangeData = clearInfoChangeData;
exports.userInfoGotten = userInfoGotten;
exports.clearPwdChangeData = clearPwdChangeData;
exports.addressInfo = addressInfo;
exports.openChangeInfoModal = openChangeInfoModal;
exports.changePwdVerifyUser = changePwdVerifyUser;
exports.changePwdVerifyMobile = changePwdVerifyMobile;
exports.realChangePwd = realChangePwd;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'goeasy-crafts/auth/LOAD';
var LOAD_SUCCESS = 'goeasy-crafts/auth/LOAD_SUCCESS';
var LOAD_FAIL = 'goeasy-crafts/auth/LOAD_FAIL';

var LOGIN = 'goeasy-crafts/auth/LOGIN';
var LOGIN_SUCCESS = 'goeasy-crafts/auth/LOGIN_SUCCESS';
var LOGIN_FAIL = 'goeasy-crafts/auth/LOGIN_FAIL';

var LOGOUT = 'goeasy-crafts/auth/LOGOUT';
var LOGOUT_SUCCESS = 'goeasy-crafts/auth/LOGOUT_SUCCESS';
var LOGOUT_FAIL = 'goeasy-crafts/auth/LOGOUT_FAIL';

var PASSWORDCHANGE = 'goeasy-crafts/auth/PASSWORDCHANGE';

var INFOCHANGESUBMIT = 'goeasy-crafts/auth/INFOCHANGESUBMIT';
var INFOCHANGESUBMIT_SUCCESS = 'goeasy-crafts/auth/INFOCHANGESUBMIT_SUCCESS';
var INFOCHANGESUBMIT_FAIL = 'goeasy-crafts/auth/INFOCHANGESUBMIT_FAIL';

var ISPERSONALUSERLOAD = 'goeasy-crafts/auth/ISPERSONALUSERLOAD';
var ISPERSONALUSERLOAD_SUCCESS = 'goeasy-crafts/auth/ISPERSONALUSERLOAD_SUCCESS';
var ISPERSONALUSERLOAD_FAIL = 'goeasy-crafts/auth/ISPERSONALUSERLOAD_FAIL';

// GETCODE, GETCODE, GETCODE_FAIL
var GETCODE = 'goeasy-crafts/auth/GETCODE';
var GETCODE_SUCCESS = 'goeasy-crafts/auth/GETCODE_SUCCESS';
var GETCODE_FAIL = 'goeasy-crafts/auth/GETCODE_FAIL';

var PASSWORDCHANGESUBMIT = 'goeasy-crafts/auth/PASSWORDCHANGESUBMIT';
var PASSWORDCHANGESUBMIT_SUCCESS = 'goeasy-crafts/auth/PASSWORDCHANGESUBMIT_SUCCESS';
var PASSWORDCHANGESUBMIT_FAIL = 'goeasy-crafts/auth/PASSWORDCHANGESUBMIT_FAIL';

var FORGETPASSWORD = 'goeasy-crafts/auth/FORGETPASSWORD';
var FORGETPASSWORD_SUCCESS = 'goeasy-crafts/auth/FORGETPASSWORD_SUCCESS';
var FORGETPASSWORD_FAIL = 'goeasy-crafts/auth/FORGETPASSWORD_FAIL';

var GETUSERINFO = 'goeasy-crafts/auth/GETUSERINFO';
var GETUSERINFO_SUCCESS = 'goeasy-crafts/auth/GETUSERINFO_SUCCESS';
var GETUSERINFO_FAIL = 'goeasy-crafts/auth/GETUSERINFO_FAIL';

var GETADDRESS = 'goeasy-crafts/auth/GETADDRESS';
var GETADDRESS_SUCCESS = 'goeasy-crafts/auth/GETADDRESS_SUCCESS';
var GETADDRESS_FAIL = 'goeasy-crafts/auth/GETADDRESS_FAIL';

// LOADPUBLIC, LOADPUBLIC_SUCCESS, LOADPUBLIC_FAIL
var LOADPUBLIC = 'goeasy-crafts/auth/LOADPUBLIC';
var LOADPUBLIC_SUCCESS = 'goeasy-crafts/auth/LOADPUBLIC_SUCCESS';
var LOADPUBLIC_FAIL = 'goeasy-crafts/auth/LOADPUBLIC_FAIL';

var LOGOUTDERECTLY = exports.LOGOUTDERECTLY = 'goeasy-crafts/auth/LOGOUTDERECTLY';

var CLEARINFOCHANGEDATA = 'goeasy-crafts/auth/CLEARINFOCHANGEDATA';
var CLEARPWDCHANGEDATA = 'goeasy-crafts/auth/CLEARPWDCHANGEDATA';
var OPENCHANGEINFOMODAL = 'goeasy-crafts/auth/OPENCHANGEINFOMODAL';

// CHANGEPWDVERIFYUSER, CHANGEPWDVERIFYUSER_SUCCESS, CHANGEPWDVERIFYUSER_FAIL
var CHANGEPWDVERIFYUSER = 'goeasy-crafts/auth/CHANGEPWDVERIFYUSER';
var CHANGEPWDVERIFYUSER_SUCCESS = 'goeasy-crafts/auth/CHANGEPWDVERIFYUSER_SUCCESS';
var CHANGEPWDVERIFYUSER_FAIL = 'goeasy-crafts/auth/CHANGEPWDVERIFYUSER_FAIL';

// CHANGEPWDVERIFYMOBILE, CHANGEPWDVERIFYMOBILE_SUCCESS, CHANGEPWDVERIFYMOBILE_FAIL
var CHANGEPWDVERIFYMOBILE = 'goeasy-crafts/auth/CHANGEPWDVERIFYMOBILE';
var CHANGEPWDVERIFYMOBILE_SUCCESS = 'goeasy-crafts/auth/CHANGEPWDVERIFYMOBILE_SUCCESS';
var CHANGEPWDVERIFYMOBILE_FAIL = 'goeasy-crafts/auth/CHANGEPWDVERIFYMOBILE_FAIL';

// REALCHANGEPWD, REALCHANGEPWD_SUCCESS, REALCHANGEPWD_FAIL
var REALCHANGEPWD = 'goeasy-crafts/auth/REALCHANGEPWD';
var REALCHANGEPWD_SUCCESS = 'goeasy-crafts/auth/REALCHANGEPWD_SUCCESS';
var REALCHANGEPWD_FAIL = 'goeasy-crafts/auth/REALCHANGEPWD_FAIL';

var GETPERSONCENTERCAROUSELIMGS = 'goeasy-crafts/auth/GETPERSONCENTERCAROUSELIMGS';
var GETPERSONCENTERCAROUSELIMGS_SUCCESS = 'goeasy-crafts/auth/GETPERSONCENTERCAROUSELIMGS_SUCCESS';
var GETPERSONCENTERCAROUSELIMGS_FAIL = 'goeasy-crafts/auth/GETPERSONCENTERCAROUSELIMGS_FAIL';

var SHOWUSERLOGINMODEL = 'goeasy-crafts/auth/SHOWUSERLOGINMODEL';
var SHOWUSERLOGINMODEL_SUCCESS = 'goeasy-crafts/auth/SHOWUSERLOGINMODEL_SUCCESS';
var SHOWUSERLOGINMODEL_FAIL = 'goeasy-crafts/auth/SHOWUSERLOGINMODEL_FAIL';

var initialState = {
  loaded: false,
  publicLoaded: false,
  pwdInfoChanging: {},
  infoChangeModalOpened: false
};
/*
 function analysisUserInfo(data) {
 let result = {};
 if (data.userInfo && data.userInfo instanceof Array) {
 result = data.userInfo[0];
 }
 return result;
 }
 function analysisSubimtResult(data) {
 const result = {};
 if (data.isValid) {
 result.userInfo = {...data.personalInfo};
 } else {
 data.submitError = data.message;
 }
 return result;
 }*/

function analysisResult(state, result) {
  var resultState = (0, _extends3.default)({}, state);
  if (result.isValid) {
    resultState.loginValid = true;
    resultState.user = result.user;
  } else {
    resultState.loginValid = false;
    resultState.loginErrorMsg = result.message;
  }
  resultState.loggingIn = false;
  return resultState;
}

function analysisAddressInfo(data, result, level, passDefValue, currentValue) {
  var retrunValue = result;
  if (!passDefValue || passDefValue === '') {
    var addressInfoArray = [];
    var defValue = void 0;
    if (data.addressData && data.addressData.defValue instanceof Array) {
      defValue = [].concat((0, _toConsumableArray3.default)(data.addressData.defValue));
    } else {
      defValue = ['', '', '', ''];
    }
    if (result.addressData && result.addressData.one instanceof Array) {
      addressInfoArray = result.addressData.one;
    }

    var newData = {};

    if (data.addressData) {
      newData = (0, _extends3.default)({}, data.addressData);
    }

    newData[level] = addressInfoArray;

    if (level === 'one') {
      newData.two = [];
      newData.three = [];
      newData.four = [];
    } else if (level === 'two') {
      newData.three = [];
      newData.four = [];
      defValue[0] = currentValue;
    } else if (level === 'three') {
      newData.four = [];
      defValue[1] = currentValue;
    } else if (level === 'four') {
      defValue[2] = currentValue;
    }

    newData.defValue = defValue;

    retrunValue = newData;
  } else {
    retrunValue = result.addressData;
  }
  return (0, _extends3.default)({}, data, { addressData: retrunValue });
}

function reducer() {
  var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
  var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  switch (action.type) {
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        user: action.result
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error
      });
    case LOADPUBLIC:
      return (0, _extends3.default)({}, state, {
        loadingPublic: true
      });
    case LOADPUBLIC_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loadingPublic: false,
        loadedPublic: true,
        publicUser: action.result
      });
    case LOADPUBLIC_FAIL:
      return (0, _extends3.default)({}, state, {
        loadingPublic: false,
        loadedPublic: false,
        error: action.error
      });
    case LOGIN:
      return (0, _extends3.default)({}, state, {
        loggingIn: true
      });
    case LOGIN_SUCCESS:
      return analysisResult(state, action.result);
    case LOGIN_FAIL:
      return (0, _extends3.default)({}, state, {
        loggingIn: false,
        user: null,
        loginError: action.error
      });
    case LOGOUT:
      return (0, _extends3.default)({}, state, {
        loggingOut: true
      });
    case LOGOUT_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loggingOut: false,
        user: null
      });
    case LOGOUT_FAIL:
      return (0, _extends3.default)({}, state, {
        loggingOut: false,
        logoutError: action.error
      });
    case INFOCHANGESUBMIT:
      return (0, _extends3.default)({}, state, {
        infoChanging: true
      });
    case INFOCHANGESUBMIT_SUCCESS:
      return (0, _extends3.default)({}, state, {
        infoChanging: false,
        infoChanged: true,
        infoChangeData: action.result
      });
    case INFOCHANGESUBMIT_FAIL:
      return (0, _extends3.default)({}, state, {
        infoChanging: false,
        infoChanged: false,
        infoChangingError: action.error
      });
    case GETADDRESS:
      return (0, _extends3.default)({}, state, {
        addressGetting: true
      });
    case GETADDRESS_SUCCESS:
      return (0, _extends3.default)({}, state, {
        addressGetting: false,
        addressGotten: true,
        userInfo: analysisAddressInfo(state.userInfo, action.result, action.level, action.defValue, action.currentValue)
      });
    case GETADDRESS_FAIL:
      return (0, _extends3.default)({}, state, {
        addressGetting: false,
        addressGotten: false,
        error: action.error
      });
    case CLEARINFOCHANGEDATA:
      return (0, _extends3.default)({}, state, {
        infoChangeModalOpened: false,
        infoChangeData: null
      });
    case OPENCHANGEINFOMODAL:
      return (0, _extends3.default)({}, state, {
        infoChangeModalOpened: true
      });
    case PASSWORDCHANGESUBMIT:
      return (0, _extends3.default)({}, state, {
        pwdChanging: true
      });
    case PASSWORDCHANGESUBMIT_SUCCESS:
      return (0, _extends3.default)({}, state, {
        pwdChanging: false,
        pwdChanged: true,
        pwdChangeData: action.result
      });
    case PASSWORDCHANGESUBMIT_FAIL:
      return (0, _extends3.default)({}, state, {
        pwdChanging: false,
        pwdChanged: false,
        pwdChangingError: action.error
      });
    case CLEARPWDCHANGEDATA:
      return (0, _extends3.default)({}, state, {
        pwdChangeData: null
      });
    case FORGETPASSWORD:
      return (0, _extends3.default)({}, state, {
        forgetPasswordSubmitting: true
      });
    case FORGETPASSWORD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        forgetPasswordSubmitting: false,
        forgetPasswordSubmitted: true
      });
    case FORGETPASSWORD_FAIL:
      return (0, _extends3.default)({}, state, {
        forgetPasswordSubmitting: false,
        forgetPasswordSubmitted: false,
        pwdChangingError: action.error
      });
    case GETCODE:
      return (0, _extends3.default)({}, state, {
        codeGetting: true
      });
    case GETCODE_SUCCESS:
      return (0, _extends3.default)({}, state, {
        codeGetting: false,
        codeGotten: true
      });
    case GETCODE_FAIL:
      return (0, _extends3.default)({}, state, {
        codeGetting: false,
        codeGotten: false,
        codeGettingError: action.error
      });
    case GETUSERINFO:
      return (0, _extends3.default)({}, state, {
        userInfoGetting: true
      });
    case GETUSERINFO_SUCCESS:
      return (0, _extends3.default)({}, state, {
        userInfoGetting: false,
        userInfoGotten: true,
        userInfo: action.result
      });
    case GETUSERINFO_FAIL:
      return (0, _extends3.default)({}, state, {
        userInfoGetting: false,
        userInfoGotten: false,
        userInfoGettingError: action.error
      });
    case CHANGEPWDVERIFYUSER:
      return (0, _extends3.default)({}, state, {
        changePwdVerifyingUser: true
      });
    case CHANGEPWDVERIFYUSER_SUCCESS:
      return (0, _extends3.default)({}, state, {
        changePwdVerifyingUser: false,
        changePwdVerifiedUser: true,
        changePwdUserInfo: action.result
      });
    case CHANGEPWDVERIFYUSER_FAIL:
      return (0, _extends3.default)({}, state, {
        changePwdVerifyingUser: false,
        changePwdVerifiedUser: false
      });
    case CHANGEPWDVERIFYMOBILE:
      return (0, _extends3.default)({}, state, {
        changePwdVerifyingMobile: true
      });
    case CHANGEPWDVERIFYMOBILE_SUCCESS:
      return (0, _extends3.default)({}, state, {
        changePwdVerifyingMobile: false,
        changePwdVerifiedMobile: true
      });
    case CHANGEPWDVERIFYMOBILE_FAIL:
      return (0, _extends3.default)({}, state, {
        changePwdVerifyingMobile: false,
        changePwdVerifiedMobile: false
      });
    case REALCHANGEPWD:
      return (0, _extends3.default)({}, state, {
        realChangingPwd: true
      });
    case REALCHANGEPWD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        realChangingPwd: false,
        realChangedPwd: true
      });
    case REALCHANGEPWD_FAIL:
      return (0, _extends3.default)({}, state, {
        realChangingPwd: false,
        realChangedPwd: false
      });
    case GETPERSONCENTERCAROUSELIMGS:
      return (0, _extends3.default)({}, state, {
        gettingPersonCenterImg: true
      });
    case GETPERSONCENTERCAROUSELIMGS_SUCCESS:
      return (0, _extends3.default)({}, state, {
        gettingPersonCenterImg: false,
        gettedPersonCenterImg: true,
        personalCenterImgsdata: action.result
      });
    case GETPERSONCENTERCAROUSELIMGS_FAIL:
      return (0, _extends3.default)({}, state, {
        gettingPersonCenterImg: false,
        gettedPersonCenterImg: false,
        personalCenterImgsError: action.error
      });
    case ISPERSONALUSERLOAD:
      return (0, _extends3.default)({}, state, {
        gettingPersonalUserInfo: true
      });
    case ISPERSONALUSERLOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        gettingPersonalUserInfo: false,
        gettedPersonUserInfo: true,
        personalUserInfo: action.result
      });
    case ISPERSONALUSERLOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        gettingPersonalUserInfo: false,
        gettedPersonUserInfo: false,
        personalUserInfoError: action.error
      });
    case SHOWUSERLOGINMODEL:
      return (0, _extends3.default)({}, state, {
        gettingShowLoginModel: true
      });
    case SHOWUSERLOGINMODEL_SUCCESS:
      return (0, _extends3.default)({}, state, {
        gettingShowLoginModel: false,
        gettedShowLoginModel: true,
        showLoginModel: action.result
      });
    case SHOWUSERLOGINMODEL_FAIL:
      return (0, _extends3.default)({}, state, {
        gettingShowLoginModel: false,
        gettedShowLoginModel: false,
        showLoginModelError: action.error
      });
    case LOGOUTDERECTLY:
      return (0, _extends3.default)({}, state, {
        user: null
      });
    default:
      return state;
  }
}

function isLoaded(globalState) {
  return globalState.auth && globalState.auth.loaded;
}

function infoChangeSubmit(info) {
  return {
    types: [INFOCHANGESUBMIT, INFOCHANGESUBMIT_SUCCESS, INFOCHANGESUBMIT_FAIL],
    promise: function promise(client) {
      return client.post('/auth', {
        data: {
          type: 'infoChange',
          info: info
        }
      });
    }
  };
}

function isPersonalUserLoaded(info) {
  return {
    types: [ISPERSONALUSERLOAD, ISPERSONALUSERLOAD_SUCCESS, ISPERSONALUSERLOAD_FAIL],
    promise: function promise(client) {
      return client.post('/auth', {
        data: {
          type: 'checkUserLoadInfo',
          info: info
        }
      });
    }
  };
}

function showUserLoginModel(info) {
  return {
    types: [SHOWUSERLOGINMODEL, SHOWUSERLOGINMODEL_SUCCESS, SHOWUSERLOGINMODEL_FAIL],
    promise: function promise(client) {
      return client.post('/auth', {
        data: {
          type: 'showUserLoginModel',
          info: info
        }
      });
    }
  };
}

function pwdChange(newPwdInfo) {
  return {
    type: PASSWORDCHANGE,
    newPwdInfo: newPwdInfo
  };
}

function pwdChangeSubmit(newPwdInfo, orderNumber) {
  return {
    types: [PASSWORDCHANGESUBMIT, PASSWORDCHANGESUBMIT_SUCCESS, PASSWORDCHANGESUBMIT_FAIL],
    promise: function promise(client) {
      return client.post('/auth', {
        data: {
          type: 'passwordChange',
          newPwdInfo: newPwdInfo,
          orderNumber: orderNumber
        }
      });
    }
  };
}

function load() {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.post('/auth', {
        data: {
          type: 'getAuthData'
        }
      });
    }
  };
}

function getPersonalCenterCarouselImgs() {
  return {
    types: [GETPERSONCENTERCAROUSELIMGS, GETPERSONCENTERCAROUSELIMGS_SUCCESS, GETPERSONCENTERCAROUSELIMGS_FAIL],
    promise: function promise(client) {
      return client.post('/auth', {
        data: {
          type: 'getPersonalCenterCarouselImgs'
        }
      });
    }
  };
}

function loadPublicUser() {
  return {
    types: [LOADPUBLIC, LOADPUBLIC_SUCCESS, LOADPUBLIC_FAIL],
    promise: function promise(client) {
      return client.post('/auth', {
        data: {
          type: 'getPublicAuthData'
        }
      });
    }
  };
}

function login(loginInfo) {
  return {
    types: [LOGIN, LOGIN_SUCCESS, LOGIN_FAIL],
    promise: function promise(client) {
      return client.post('/login', {
        data: {
          loginInfo: loginInfo
        }
      });
    }
  };
}

function logout() {
  return {
    types: [LOGOUT, LOGOUT_SUCCESS, LOGOUT_FAIL],
    promise: function promise(client) {
      return client.get('/logout');
    }
  };
}

function forgetPasswordSubmit(mobileInfo) {
  return {
    types: [FORGETPASSWORD, FORGETPASSWORD_SUCCESS, FORGETPASSWORD_FAIL],
    promise: function promise(client) {
      return client.post('/auth', {
        data: {
          type: 'forgetPassword',
          mobileInfo: mobileInfo
        }
      });
    }
  };
}

function getCode(mobile, isPublic, fromSession) {
  // console.log(mobile);
  return {
    types: [GETCODE, GETCODE_SUCCESS, GETCODE_FAIL],
    promise: function promise(client) {
      return client.post('/auth', {
        data: {
          type: 'getCode',
          mobile: mobile,
          isPublic: isPublic,
          fromSession: fromSession
        }
      });
    }
  };
}

function getUserInfo() {
  return {
    types: [GETUSERINFO, GETUSERINFO_SUCCESS, GETUSERINFO_FAIL],
    promise: function promise(client) {
      return client.post('/auth', {
        data: {
          type: 'getUserInfo'
        }
      });
    }
  };
}

function clearInfoChangeData() {
  return {
    type: CLEARINFOCHANGEDATA
  };
}

function userInfoGotten(globalState) {
  return globalState.auth && globalState.auth.userInfoGotten;
}

function clearPwdChangeData() {
  return {
    type: CLEARPWDCHANGEDATA
  };
}

function addressInfo(data, level) {
  return {
    types: [GETADDRESS, GETADDRESS_SUCCESS, GETADDRESS_FAIL],
    level: level,
    defValue: data.defValue,
    currentValue: data.value,
    promise: function promise(client) {
      return client.post('/auth', {
        data: {
          type: 'getAddressInfo',
          data: data
        }
      });
    }
  };
}

function openChangeInfoModal() {
  return {
    type: OPENCHANGEINFOMODAL
  };
}

function changePwdVerifyUser(data) {
  return {
    types: [CHANGEPWDVERIFYUSER, CHANGEPWDVERIFYUSER_SUCCESS, CHANGEPWDVERIFYUSER_FAIL],
    promise: function promise(client) {
      return client.post('/auth', {
        data: {
          type: 'changePwdVerifyUser',
          user: data.userInfo
        }
      });
    }
  };
}

function changePwdVerifyMobile(data) {
  return {
    types: [CHANGEPWDVERIFYMOBILE, CHANGEPWDVERIFYMOBILE_SUCCESS, CHANGEPWDVERIFYMOBILE_FAIL],
    promise: function promise(client) {
      return client.post('/auth', {
        data: {
          type: 'changePwdVerifyMobile',
          data: data
        }
      });
    }
  };
}

function realChangePwd(data) {
  return {
    types: [REALCHANGEPWD, REALCHANGEPWD_SUCCESS, REALCHANGEPWD_FAIL],
    promise: function promise(client) {
      return client.post('/auth', {
        data: {
          type: 'realChangePwd',
          data: data
        }
      });
    }
  };
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/redux/modules/auth.js
 ** module id = 31
 ** module chunks = 0
 **/